export default "__VITE_ASSET__3df87da6__"